import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { SecurityContext } from "@angular/core";

@Component({
  selector: "app-pdf-preview-modal",
  templateUrl: "./pdf-preview-modal.component.html",
  styleUrls: ["pdf-preview-modal.component.css"],
})
export class PdfPreviewModalComponent {
  constructor(
    public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer
  ) {}

  // PDFファイル
  @Input() previewUrl: SafeResourceUrl = null;
  // 後処理のあるなし
  @Input() postProcess: boolean = false;
  // 後処理のボタン名
  @Input() postProcessButtonText: string = "アップロード";

  ret: any = {
    status: "",
  };

  /**
   * プレビューモーダルを閉じる
   */
  close() {
    this.ret.status = "close";
    this.activeModal.close(this.ret);
  }

  /**
   * 後処理がある場合の処理（モーダルは閉じる）
   */
  async processing() {
    this.ret.status = "ok";
    this.activeModal.close(this.ret);
  }

  /**
   * PDFのダウンロード処理
   */
  async download() {
    const url = this.sanitizer.sanitize(
      SecurityContext.RESOURCE_URL,
      this.previewUrl
    );
    if (!url) return;
    const u = new URL(url, window.location.origin);
    const fileParam = u.searchParams.get("file");
    if (!fileParam) throw new Error("file パラメータがありません");
    const fileUrl = decodeURIComponent(fileParam);
    const a = document.createElement("a");
    a.href = fileUrl;
    a.download = "download.pdf";
    a.click();
  }
}



// WEBPACK FOOTER //
// ./src/app/parts/pdf/pdf-preview-modal/pdf-preview-modal.component.ts